import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HomeZoneProps {
  id: string;
  /** Small uppercase eyebrow label shown at the section break. */
  eyebrow: string;
  title: string;
  blurb?: string;
  /** Alternating surface shade so zones read as distinct bands. */
  tone?: "base" | "raised";
  children: ReactNode;
}

/**
 * One of the four homepage zones. Each zone owns a background shade,
 * a top border break and an eyebrow label so the page reads as
 * "Right now / Do something / Go deeper / Stay in the loop".
 */
export function HomeZone({ id, eyebrow, title, blurb, tone = "base", children }: HomeZoneProps) {
  return (
    <section
      id={id}
      aria-label={title}
      className={cn(
        "scroll-mt-24 border-t border-border/60",
        tone === "raised" ? "bg-muted/30" : "bg-background",
      )}
    >
      <div className="container mx-auto px-4 pt-6 pb-2">
        <div className="type-eyebrow text-primary">{eyebrow}</div>
        <h2 className="mt-1 type-section-title">{title}</h2>
        {blurb && <p className="mt-1 text-sm text-muted-foreground max-w-2xl">{blurb}</p>}
      </div>
      <div className="pb-6">{children}</div>
    </section>
  );
}
